import { t } from 'i18next';

export function StaffBadge() {
  return (
    <span className="ms-2 inline-flex items-center rounded-md bg-linear-to-r from-fuchsia-500 to-blue-500 px-1.5 py-0.5 text-white text-xs">
      {t('labels:staff-only')}
    </span>
  );
}
